import { render, staticRenderFns } from "./mCareIntegrationContactsProfiles.vue?vue&type=template&id=17f14847&scoped=true"
import script from "./mCareIntegrationContactsProfiles.ts?vue&type=script&lang=ts&external"
export * from "./mCareIntegrationContactsProfiles.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f14847",
  null
  
)

export default component.exports